export default "__VITE_PUBLIC_ASSET__cf27a969__"